import { useMemo } from 'react';
import {
  EXTERNAL_STAKEHOLDERS_FIXTURE,
  ExternalStakeholdersResponse
} from './external-stakeholders-constants';
import { orderExternalStakeholders } from './external-stakeholders-utils';

interface UseExternalStakeholdersResult {
  data: ExternalStakeholdersResponse | undefined;
  isLoading: boolean;
  isError: boolean;
}

// Returns the fixture synchronously until the external-stakeholders endpoint exists.
export const useExternalStakeholders = (): UseExternalStakeholdersResult => {
  const data = useMemo(
    () => ({
      ...EXTERNAL_STAKEHOLDERS_FIXTURE,
      stakeholders: orderExternalStakeholders(EXTERNAL_STAKEHOLDERS_FIXTURE.stakeholders)
    }),
    []
  );

  return { data, isLoading: false, isError: false };
};
